var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\n      .cls-2 {\n        fill: #cccccc;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.278,0.270 C-0.110,0.653 -0.110,1.273 0.278,1.657 C0.278,1.657 6.241,7.542 6.241,7.542 C6.630,7.925 7.259,7.925 7.647,7.542 C7.647,7.542 13.611,1.657 13.611,1.657 C13.805,1.465 13.902,1.214 13.902,0.963 C13.902,0.712 13.805,0.461 13.611,0.270 C13.222,-0.114 12.593,-0.114 12.205,0.270 C12.205,0.270 6.944,5.461 6.944,5.461 C6.944,5.461 1.683,0.270 1.683,0.270 C1.295,-0.114 0.666,-0.114 0.278,0.270 Z",
    id: "path-1",
    className: "cls-2",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.ec29fb5a.svg";
export { ForwardRef as ReactComponent };